import React from "react";
import styled from "styled-components";

const Accordion = ({
  index,
  activeIndex,
  question,
  answer,
  toggleAccordion,
}) => {
  const isActive = activeIndex === index;

  return (
    <AccordionItem>
      <AccordionHeader
        onClick={() => toggleAccordion(index)}
        aria-expanded={isActive}
      >
        {question}
        <AccordionIcon>{isActive ? "-" : "+"}</AccordionIcon>
      </AccordionHeader>
      {isActive && <AccordionContent>{answer}</AccordionContent>}
    </AccordionItem>
  );
};

const AccordionItem = styled.div`
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  cursor: pointer;
  background-color: #f7f7f7;
  font-size: 1.2em;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 1.1em;
    padding: 12px;
  }

  @media (max-width: 480px) {
    font-size: 1em;
    padding: 10px;
  }
`;

const AccordionIcon = styled.span`
  font-size: 1.5em;

  @media (max-width: 768px) {
    font-size: 1.3em;
  }

  @media (max-width: 480px) {
    font-size: 1.2em;
  }
`;

const AccordionContent = styled.div`
  padding: 15px;
  background-color: #fff;
  font-size: 1em;
  line-height: 1.6;

  @media (max-width: 768px) {
    padding: 12px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    font-size: 0.9em;
  }
`;

export default Accordion;
